module.exports = __webpack_public_path__ + "public/images/Illustration_Subjects_200x200-Color.521eebc96655a62eacca611d8ba1a54c.png";